import {RemoteGetExamsList} from 'data/usecases/private/my-hospitalization/remote-get-exams-list';
import {GetExamsList} from 'domain/usecases/private/my-hospitalization/get-exams-list';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {MyHospitalizationEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetExamsList = (): GetExamsList =>
	new RemoteGetExamsList(
		makeBFFApiUrl(MyHospitalizationEndpoints.examsList),
		makeAuthorizeHttpClientDecorator(),
	);
